import { render } from "./CustomerResume.vue?vue&type=template&id=6bd6aa50"
import script from "./CustomerResume.vue?vue&type=script&lang=js"
export * from "./CustomerResume.vue?vue&type=script&lang=js"

import "./CustomerResume.vue?vue&type=style&index=0&id=6bd6aa50&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__